import React, { useContext } from 'react';
import { FaPlus, FaTimes } from 'react-icons/fa';
import { LanguageContext } from '../../context/LanguageContext';
import './TabManager.css';

const TabManager = ({ tabs, activeTab, onTabChange, onNewTab, onCloseTab }) => {
  const { t } = useContext(LanguageContext);

  return (
    <div className="tab-manager">
      <div className="tabs-container">
        {tabs.map((tab, index) => (
          <div
            key={tab.id}
            className={`tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            <span className="tab-title">{`${t('cashier.tabs.order')} ${index + 1}`}</span>
            {tabs.length > 1 && (
              <button
                className="close-tab"
                onClick={(e) => {
                  e.stopPropagation();
                  onCloseTab(tab.id);
                }}
              >
                <FaTimes />
              </button>
            )}
          </div>
        ))}
      </div>
      <button className="new-tab-button" onClick={onNewTab}>
        <FaPlus />
      </button>
    </div>
  );
};

export default TabManager;
